const BaseConfigService = require('./BaseConfigService');

/**
 * Google Pay Configuration Service
 *
 * Manages Google Pay specific configuration with validation and defaults
 */
class GooglePayConfigService extends BaseConfigService {
  /**
   * Get default Google Pay configuration
   */
  _getDefaultConfig() {
    return {
      merchant_id: null,
      merchant_name: null,
      gateway: null,
      gateway_merchant_id: null,
      fee: null,
      fee_description: null,
      code: null,
      country_code: null,
      currency_code: null,
      environment: null,
      total_price: null,
      payment_url: null,
      apiVersion: null,
      apiVersionMinor: null,
      allowedCardNetworks: null,
      allowedCardAuthMethods: null,
      tokenizationSpecificationType: null,
      baseCardPaymentMethodType: null,
      totalPriceStatus: null,
      totalPriceLabel: null,
      displayItems: null,
      publicKey: null,
      emailRequired: null,
      existingPaymentMethodRequired: null,
      allowPrepaidCards: null,
      allowCreditCards: null,
      billingAddressRequired: null,
      billingAddressParameters: null,
      assuranceDetailsRequired: null,
      buttonLocale: null,
      theme: null,
    };
  }

  /**
   * Apply configuration with mappings
   */
  _applyConfig(config) {
    const mappings = {
      merchant_id: 'merchant_id',
      merchant_name: 'merchant_name',
      gateway: 'gateway',
      gateway_merchant_id: 'gateway_merchant_id',
      fee: 'fee',
      fee_description: 'fee_description',
      code: 'code',
      country_code: 'country_code',
      currency_code: 'currency_code',
      environment: 'environment',
      total_price: 'total_price',
      payment_url: 'payment_url',
      apiVersion: 'apiVersion',
      apiVersionMinor: 'apiVersionMinor',
      allowedCardNetworks: 'allowedCardNetworks',
      allowedCardAuthMethods: 'allowedCardAuthMethods',
      tokenizationSpecificationType: 'tokenizationSpecificationType',
      baseCardPaymentMethodType: 'baseCardPaymentMethodType',
      totalPriceStatus: 'totalPriceStatus',
      totalPriceLabel: 'totalPriceLabel',
      totalPrice: 'total_price', // Note: maps to total_price
      displayItems: 'displayItems',
      gatewayMerchantId: 'gateway_merchant_id',
      publicKey: 'publicKey',
      merchantId: 'merchant_id',
      merchantName: 'merchant_name',
      emailRequired: 'emailRequired',
      existingPaymentMethodRequired: 'existingPaymentMethodRequired',
      allowPrepaidCards: 'allowPrepaidCards',
      allowCreditCards: 'allowCreditCards',
      billingAddressRequired: 'billingAddressRequired',
      billingAddressParameters: 'billingAddressParameters',
      assuranceDetailsRequired: 'assuranceDetailsRequired',
      buttonLocale: 'buttonLocale',
      theme: 'theme',
      googlePayLoaded: 'googlePayLoaded',
    };

    Object.entries(mappings).forEach(([sourceKey, targetKey]) => {
      if (typeof config[sourceKey] !== 'undefined') {
        this._config[targetKey] = config[sourceKey];
      }
    });
  }

  /**
   * Check if Google Pay is configured
   */
  isConfigured() {
    return !!(this._config.merchant_id || this._config.gateway_merchant_id);
  }
}

// Export singleton instance
module.exports = new GooglePayConfigService();
